module.exports={
    btn:{
        tips_reelect_btn:"新图片",
        cancel_btn:"取消",
        tips_continue_dispose:"忽略不支持的文件",
        tips_return:"新图片",
        tips_upgrade:"升级",
        tips_yes:"确定",
        delete:"删除",
        download:"下载",
        upload_image:"上传图片",
        new_image:"新图片",
        save_all:"保存全部",
        cancel:"取消",
        save:"保存",
        view_comparison:"查看比较",
        hide_comparison:"隐藏比较",
        previous:"上一张",
        next:"下一张",
        continue_download:"保存带水印的图片",
        present:"应用于此图",
        all_wait:"应用于等待中的图片",
        all:"应用于所有图片",
        history:"历史记录",
        login:"登录",
    },
    tips:{
        please_upgrade:"您当前的权益不支持批量处理。请升级后解锁。",
        errorlistinfo:"共选择XXX个文件。XXX张图片支持处理,XXX个文件不支持。以下是不受支持的文件:",
        max:"超过10MB的大小限制!",
        max_size:"超过最长边4096px的尺寸限制!",
        continue_dispose:"忽略不支持的文件",
        please_multiple:"请选择放大倍数",
        max_multiple:"*最高可将图片放大至4K(最长边不超过4096px)。",
        title:"文件名",
        reasons:"原因",
        upload_type:"格式不支持",
        used_up:"下载无水印高清图片的次数已用完。请再次升级或下载带水印的图片。",
        edit_multiple:"您有多张图片，请选择修改的倍数将应用于哪些图片。",
        download_confirm:"您有图片未完成，确定保存当前所有已完成的图片吗？重复保存不会重复扣除次数。",
        waiting_save:"一些图片还在处理中。请稍后保存。",
        
    },
    header:{
        title:"Aiseesoft在线图像超分",
        hd:" 次",
        watermarks:"无水印高清图片次数可供消耗。",
        view_details:"查看详情",
        loading:"加载中...",
    },
    content:{
        failed:"失败",
        completed:"完成",
        processing:"处理中",
        img_processing:"处理中...",
        
        img_failed:"处理失败",
        uploading:"上传中",
        img_uploading:"上传中...",
        wait_upoading:"等待上传...",
        waiting:"等待中",
        img_waiting:"等待中...",
        empty:"空空如也",
        magnification:"放大倍数:",
        drop:"或拖拽图片到这里",
        original:"原图:",
        output:"放大后:",
        img_rendering1:"图片已超分完成。",
        img_rendering2:"正在努力渲染高清大图以供查看预览，请稍等...",
        no_watermark:"图片下载后为无水印版本",
    },
    banner_msg:"为图片放大选择一个计划",
    monthly:"每月",
    lifetime:"终身",
    choose_plan:"根据图像数量选择您的计划",
    return_home:"恭喜！ 您已成功升级。 请返回首页使用本产品。",
    congratulations:"恭喜！ 您已成功升级。 福利已与您升级时留下的邮箱绑定。 请使用注册或链接到电子邮件地址的帐户",
    login_benefits:"登录使用福利",
    no_registered:"。如果您还没有注册或链接到电子邮件地址的帐户，请",
    register_account:"使用电子邮件地址注册帐户",
    other_accounts:"或将其他帐户链接到此电子邮件地址以使用福利。",
    btn_close:"关闭",
    free:"免费",
    btn_get_started:"开始吧",
    // access_to:"进入",
    upscale_images:"高档图片",
    up_to:"最高",
    per_image:"每张图片",
    resolution_of:"分辨率为",
    default_level:"默认级别的高档图像",
    image_downloads:"2张无水印高清图片下载",
    unlimited_image:"带水印的无限图像下载",
    SHA256_encryption:"SHA256加密技术",
    mon:"每月",
    images:"图片",
    high_resolution:"具有高分辨率的质量",
    tax_incl:"含税",
    image:"图像",
    secure_checkout:"安全支付",
    everything:"一切都免费，而且",
    upscaling_levels:"可以选择所有升级级别",
    unlimited_image_without:"无水印无限制图像下载",
    viewable_editing:"可查看的编辑历史适用于",
    days:"天",
    high_level:"高水平",
    priority_processing:"优先处理",
    left:"终身",
    resolution:"分辨率",


    "history_will":"将在之后过期",
    "history.days":"天",
    "history.hours":"小时",
    "expired":"已过期",
    "access_to":"通过免费试用，您只能",
    "pricing.upload_images":"上传图片",
    "pricing.under":"小于",
    "pricing.images":"张图片",
    "pricing.without_watermark":"无水印",
    "pricing.process_images":"处理图像高达",
    "pricing.pixels":"像素",
    "pricing.enjoy_limited":"订阅权益可试用",
    "pricing.download":"可下载",
    "pricing.HD_images":"张无水印高清图",
    "pricing.and_you":"您可能会遇到",
    "pricing.slow_upscaling":"长久等待",
    "pricing.lower_priority":"低优先级的问题",
    "pricing.without":"无水印",
    "pricing.tax":"税费包含在销售价格中，将根据您所在的国家和地区自动计算。在购物车中您可以看到详细的税额。您的最终付款金额应与显示的价格相同。",
    "pricing.you_can":"通过订阅，您可以",
    "pricing.up_to":"上传图片最大",
    "pricing.upscale_images":"放大图像",
    "pricing.no_watermark":"无水印",
    "pricing.enhance":"可",
    "pricing.or_more":"张图片或更多图片",
    "pricing.in_batch":"批量处理",
    "pricing.enlarge_images":"享受图像",
    "pricing.and":"和",
    "pricing.times_with":"放大，无次数限制",
    "pricing.enjoy":"享受",
    "pricing.of_history":"历史存储时间",
    "pricing.experience":"体验",
    "pricing.fast_upscaling":"快速通道",
    "pricing.higher_priority":"更高的优先级",
    "pricing.early_access":"抢先体验新功能",
    "pricing.cancel_anytime":"随时取消",
    "pricing.lifetime_license":"通过终身买断，您可以",
    "pricing.and_there":"而且额度",
    "pricing.no_expiration":"没有有效期",
    "pricing.unless":"直到用尽",

    "buynow.pop.credit":"点",
    "buynow.pop.credits":"点",

    "isUnderequityTip_msg1":"您选择了{%}张图片进行批是处理，剩余权益不足，还需{%}点(目前剩余{%}点权益)，如需处理请购买权益以继续处理图像。",
    "isUnderequityTip_msg2":"您选择了{%}张图片进行批是处理，剩余权益不足，还需{%}点(目前剩余{%}张权益)，如需处理请购买权益以继续处理图像。",
    "isUnderequityTip_msg3":"您选择了{%}张图片进行批是处理，剩余权益不足，还需{%}点(目前剩余{%}点、{%}张权益)，如需处理请购买权益以继续处理图像。",
    "btn_buy_now":"立即购买",
    "isEquityDepletionTip_msg":"您当前的权益已经用尽，请购买权益以进行批处理",
}